import { useAppSelector } from 'hooks/redux';
import React from 'react';
import { Outlet } from 'react-router-dom';

import { featureFlagsSelectors } from 'app-components/flux/feature-flags';
import { localPreferences } from 'app-components/utils/core';

import NavigateSetter from 'NavigateSetter';
import ErrorBoundary from 'components/ErrorBoundary';
import RootModal from 'components/RootModal';
import VersionDisplay from 'containers/App/VersionDisplay';
import Maintenance from 'containers/Maintenance';
import OfflinePage from 'containers/OfflinePage';
import ServiceWorkers from 'containers/ServiceWorkers';
import * as appSelectors from 'data/app/selectors';
import LaunchDarkly from 'utils/LaunchDarkly';

///////////////////////////////////////////////////////////////////////////////////////////////////////////////
import DevMenuInternal from 'containers/App/DevMenu';
/////////

let DevMenu: any;
DevMenu = null;
///////////////////////////////////////////////////////////////////////////////////////////////////////////////
DevMenu = DevMenuInternal;
/////////

const LayoutLoggedOut = () => {
  const isOffline = useAppSelector(appSelectors.getIsOffline);
  const isMaintenance = useAppSelector((state) => featureFlagsSelectors.getFeatureFlag(state, 'maintenance'));

  if (isOffline && !localPreferences.getOfflineSupport()) {
    return (
      <ErrorBoundary>
        <OfflinePage />
      </ErrorBoundary>
    );
  }

  return (
    <>
      {isMaintenance ? (
        <ErrorBoundary>
          <Maintenance />
        </ErrorBoundary>
      ) : (
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      )}

      <ErrorBoundary>
        <VersionDisplay />
      </ErrorBoundary>

      <ErrorBoundary>
        <RootModal />
      </ErrorBoundary>

      <ErrorBoundary>
        {/*
         // @ts-expect-error FIXME TS2741 */}
        <NavigateSetter />
      </ErrorBoundary>

      <ErrorBoundary>
        <ServiceWorkers />
      </ErrorBoundary>

      <React.StrictMode>
        <ErrorBoundary>{DevMenu && <DevMenu />}</ErrorBoundary>
      </React.StrictMode>

      <ErrorBoundary>
        <LaunchDarkly />
      </ErrorBoundary>
    </>
  );
};

export default LayoutLoggedOut;
